import { useCallback } from 'react';
import { RedirectBasedPayment } from '../common/GenericPayment/RedirectBasedPayment';

export const XpressBillPayForm = ({ loading, onPay, permitIdentifier, totalDue, error }) => {
  const handleClickCallback = useCallback(async () => {
    const { url } = await onPay();

    const sURLParams = new URLSearchParams();

    // This is from the Single Permit view
    sURLParams.set('id', permitIdentifier);

    const windowUrl = new URL(`${url}?${sURLParams}`);

    return { url: windowUrl };
  }, [permitIdentifier]);

  return (
    <RedirectBasedPayment
      totalDue={totalDue}
      onClickCallback={handleClickCallback}
      loading={loading}
      error={error}
    >
      The button below will take you to the Xpress Bill Pay system to make your payment. A 2% service charge will be added if paying with a credit card.
    </RedirectBasedPayment>
  );
};
